import { render, staticRenderFns } from "./serviceGroup.vue?vue&type=template&id=889a8596&scoped=true&"
import script from "./serviceGroup.vue?vue&type=script&lang=js&"
export * from "./serviceGroup.vue?vue&type=script&lang=js&"
import style0 from "./serviceGroup.vue?vue&type=style&index=0&id=889a8596&lang=less&scoped=true&"
import style1 from "./serviceGroup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889a8596",
  null
  
)

component.options.__file = "serviceGroup.vue"
export default component.exports